import { Link } from "react-router-dom";

import ImgAnimationHeader from "../../acets/img_site/header-img.svg"
import ImgAnimationCarrinho from "../../acets/img_site/carrinnho.svg"
import ImgCellContato from "../../acets/img_site/imgrelogiocontato.svg"

import IconMenuPreco from"../../acets/img_site/precos.svg"
import IconMenuHome from"../../acets/img_site/home.svg"
import IconMenuVantagens from"../../acets/img_site/servicos.svg"
import IconMenuContato from"../../acets/img_site/contato.svg"
import IconMenuSobre from"../../acets/img_site/sobre.svg"
import IconLogo from"../../acets/img_site/novalogo.png"

import Imgebook01 from"../../acets/img_leadpage/ebook01.png"
//import Docebookpdf1 from "../../acets/pdfs/ebookgratuito02.pdf"

import ImgIconCheck from "../../acets/img_site/checked.svg"
import ImgIconNocheck from "../../acets/img_site/nochecked.svg"
//import ImgCell from "../../acets/img_site/cell.png"
import LogoCell from "../../acets/img_icon/logocellsite.svg"
//import ImgWpp from "../../acets/img_site/wpp.jpg"
import ImgWpp from "../../acets/img_icon/wpp.png"
import ImgNewWpp from "../../acets/img_site/newwpp.svg"
import { useEffect, useState } from "react";
import axios from "axios";
import Contador from "../partils/ContatorRegressivo"
import IconPainelDemo from"../../acets/img_site/paineldemo.gif"


export default function PageIndex(){
   
const [terms,setTerms]=useState(true)
const [newlaster,setnewlaster]=useState(false)

const initialValues={ // DEFININDO UMA CONST PARA O STATE INICIAL 
    nome: '',telefone:'',email:'afiliados@gmail.com',porte:'22'
}
const [values, setValues]=useState(initialValues) // INICIANDO UM STATE

useEffect(() => {
    const timeoutId = setTimeout(() => {
            setnewlaster(true)
    }, 20000); // Tempo em milissegundos para o timeout
    return () => clearTimeout(timeoutId);
  }, []);


function onChange(ev) {//ALTERAR OS STATES DOS INPUTS
    const {name, value} = ev.target; //ESTRAIR O NAME E VALUE DO EV
    setValues({ ...values, [name]:value }); //SETANDO O VALUE EM NAME
}
function onSubmit(ev){
        ev.preventDefault();
        //nome: '',telefone:'',email:'',porte:'MEI'
        //const inputIsChecked = document.getElementById('vehicle1');
        //console.log(inputIsChecked)
        if(values.nome,values.telefone===""){
            alert("ATENÇÃO. Preencha os campos de nome, telefone, aceite de email e porte obrigatoriamente")
        }
        else{
            axios.post('/api/leads',values).then(()=>{
                setValues(initialValues);
                alert("Sucesso! Entraremos em contato em breve, em até 24h!")
            })
        }
}

  /*
window.Notification.requestPermission(permission=>{
    if(permission==='granted'){
        new window.Notification('Habits',{
            body:'Textoh'
        })
    }
}) <img src={Imgebook01} alt="imagem capa do ebook" className="w60 cell-tamanho"/>
*/
//---------------------------------------------------------------------------------
    return(
      <div className="w100 column center">
        <section className="w100 h80  column center pcb50">
            
            <div className="w80 wmax1200 pcb20 row around">
                    
                    <div className="w50 column cell-tamanho ">
                        <div className="column aligitensstart w100 ">
                            <img src={IconLogo} alt="logo da empresa" style={{width:'80px', height:'80px'}}/>
                            <label className="fb">Auto Metricas</label>
                        </div>
                       
                        <h4 className="w100 cell-text-subtitle cell-margin10 ma10b0">Programa de Afiliados</h4>
                            <label className="w100 ma10b0 cell-tamanho roboto cell-text-smile fs1p3em">Afiliados inteligentes ganham duas vezes: ajudam os amigos e lucram por essa ajuda. 🚀</label>
                            
                            <label className="ma10b0 cell-tamanho roboto cell-text-smile fs1p3em">🚀 Ganhe dinheiro sem sair de casa! Indique nosso sistema e receba todo mês 💵 👉 Faça o cadastro agora mesmo!
                            </label>
                            <label className="fs1p3em pcb20">A sua franquia de 50 Reais. Vagas limitadas!</label>
                            <Contador/>
                    </div>
                    <div className="w50 column center cell-tamanho">
                        <div className="w80 h40 cell-tamanho  cont-circ8 column center b2 sombra wmax1200">
                            <form className="w80 pcb50" onSubmit={onSubmit} autoComplete='off'id="cadastro"> 
                                <h4>Cadastro</h4>
                                <label className="c5">Nome completo:</label>
                                <input type="text" name="nome" onChange={onChange} value={values.nome}></input>
                                <label className="c5">Telefone/WhatsApp:</label>
                                <input type="number" name="telefone" onChange={onChange} value={values.telefone}></input>
                                <label className="c5">Termos:</label>
                            
                                <div className="pcb10">
                                    <input 
                                        type="checkbox" 
                                        id="vehicle1" 
                                        className="pp" 
                                        checked={values.acceptEmails} 
                                        onChange={(e) => setValues({ ...values, acceptEmails: e.target.checked })}
                                    />
                                    <label className="pp c5" htmlFor="vehicle1">Aceito os termos</label>
                                </div>
                                {!values.acceptEmails || values.email === '' || !values.email.includes('@') || values.nome === '' || values.telefone === ''?
                                <div className="w100 b6 pcb10 column center cont-circ c2" onClick={()=>alert('OPS.... Preencha os campos nome e telefone e aceite os termos')}>Cadastrar</div>:
                                <button type="submit" value="Continuar com o cadastro" className="btn06 w100"> Cadastrar</button>
                                }
                            </form>
                         </div>
                    </div>
            </div>
        </section>        
      
        <section className="w100 h40 b2 column center">
            <div className="w80">
               <h4 className="w100 cell-text-subtitle cell-margin10 ma10b0">Quanto você vai ganhar?</h4>
               <label>Calculadora</label>
               <div className="w100 ma10b0 b3 row between celular">
                    <div className="w30 h20 column center b2 borda1 cell-tamanho">
                        <label className="fs2em fb">7</label>
                        <label>indicações ativas</label>
                        <label className="linha fs1p3em fb ma10b0">Recebe R$: 420<strong>/Mês</strong></label>
                        <label className="fs09em">Tempo médio para alcançar: 1 ano</label>
                        <label className="fs09em">Média de Abordagens 200 p/Ano</label>
                        <label className="fs09em">Média de 4 contatos p/Semana</label>


                    </div>
                            
                    <div className="w30 h20 column center cell-tamanho">
                        <label className="fs2em fb">20</label>
                        <label>indicações ativas</label>
                         <label className="linha fs1p3em fb ma10b0"> Recebe R$: 1200<strong>/Mês</strong></label>
                    </div>

                    <div className="w30 h20 column center cell-tamanho">
                        <label className="fs2em fb">45</label>
                        <label>indicações ativas</label>
                        <label className="linha fs1p3em fb ma10b0">Recebe R$: 2700<strong>/Mês</strong></label>
                    </div>
               </div>
            </div>
            <label>Indicações minima para começar a receber: 2</label>

        </section>
        
        <section className="w100 h80 b2 column center b31">
            <div className="w80 ">
                <h4 className="w100 cell-text-subtitle cell-margin10 ma20b0">Como começar?</h4>
                <div className="ma10b0 b2 pcb20 column center">
                    <div className="w90">
                        <label className="fb fs1p1em">1º passo</label>
                    </div>
                    <div className="w80 column start aligitensstart">
                        <label>Cadastre-se no formulario acima e aguarde a ativação do seu plano</label>
                        <label>Pague a taxa de ativação de R$:50 Reais</label>
                    </div>
                   
                </div>
                <div className="ma10b0 b2 pcb20 column center">
                    <div className="w90">
                        <label className="fb fs1p1em">2º passo</label>
                    </div>
                    <div className="w80 column start aligitensstart">
                        <label>Entre no link de academy e estude sobre como abordar os seus clientes de forma leve.</label>
                        <label>Copie os textos e mande para os seus conhecidos</label>
                    </div>
                   
                </div>
                <div className="ma10b0 b2 pcb20 column center">
                    <div className="w90">
                        <label className="fb fs1p1em">3º passo</label>
                    </div>
                    <div className="w80 column start aligitensstart">
                        <label>Faça o login na plataforma com as credencias de uso que você recebeu após o pagamento</label>
                        <label>Vá até o menu de "Dados empresa" e selecione "Add empresa" e preencha os dados do seu cliente</label>
                    </div>
                   
                </div>
                <div className="ma10b0 b2 pcb20 column center">
                    <div className="w90">
                        <label className="fb fs1p1em">4º passo</label>
                    </div>
                    <div className="w80 column start aligitensstart">
                        <label>Envie o login e senha que você criou e mande para o seu cliente</label>
                        <label>Envie o contato do nosso suporte e o contato do nosso time de treinamento para o seu cliente</label>
                    </div>
                   
                </div>
                <div className="ma10b0 b2 pcb20 column center">
                    <div className="w90">
                        <label className="fb fs1p1em">5º passo</label>
                    </div>
                    <div className="w80 column start aligitensstart">
                        <label>Cadastre a sua chave pix para o recebimento das mensalidades</label>
                        <label>Informe ao suporte tecnico sobre o treinamento com os novos clientes</label>
                    </div>
                   
                </div>
                
            </div>
            
        </section>

        <section className="w100 h80 column center pcb50 b2" id="vantagens">
                <div className="w80 wmax1200 pcb20 row center">
                        <h4 className="w100 cell-text-subtitle cell-margin10">O que você vai vender?</h4>
                        <label className="fs1p3em">Um sistema de gestão para pequenos e médios negócios, uma ferramenta essencial para entender os numeros de um negocio. integrado a um catalogo/loja online. Fique tranquilo que vamos lhe explicar tudo e se preferir o nosso time pode entrar no processo de vendas para fazer a ponte entre você e o seu cliente.</label>
                        <div className="w60 column cell-tamanho ">
                                <h5 className="ma10b0 cell-content"></h5>
                                <img src={IconPainelDemo} className="w100 sombra" alt="imagem de mecanico na oficina"/>
                        
        
                            
                        </div>
                        <div className="w40 cell-tamanho">
                            <div className="w100 h60 row end celular">
                                <div className="w60 h60 b10 cont-circ7 column between sombra cell-tamanho cell-margin10">
                                    <h4 className="w100 cen pcb10 c3">Preço</h4>
                                    <div className="row w90 cell-padding4">
                                        <img src={ImgIconCheck} alt="ok" className="p7 cell-padding4"></img>
                                        <label className="fs08em c3">Crie a sua loja online</label>
                                    </div>
                                    <div className="row w90">
                                        <img src={ImgIconCheck} alt="ok" className="p7 cell-padding4"></img>
                                        <label className="fs08em c3">Cadastro de produtos e serviços</label>
                                    </div>
                                    <div className="row w90">
                                        <img src={ImgIconCheck} alt="ok" className="p7 cell-padding4"></img>
                                        <label className="fs08em c3">Faturamento Diário no WhatsApp</label>
                                    </div>
                                    <div className="row w90">
                                        <img src={ImgIconCheck} alt="ok" className="p7 cell-padding4"></img>
                                        <label className="fs08em c3">Orçamentos no WhatsApp</label>
                                    </div>
                                    <div className="row w90">
                                        <img src={ImgIconCheck} alt="no" className="p7 cell-padding4"></img>
                                        <label className="fs08em c3">Relatórios de desempenho</label>
                                    </div>
                                    <div className="row w90">
                                        <img src={ImgIconCheck} alt="ok" className="p7 cell-padding4"></img>
                                        <label className="fs08em c3">Relógio de ponto</label>
                                    </div>
                                    <div className="row w90">
                                        <img src={ImgIconCheck} alt="no" className="p7 cell-padding4"></img>
                                        <label className="fs08em c3">Agendamentos</label>
                                    </div>
                                    
                                        <p className="fs06em c3 fb fs1p3em pcb10">Primeiro Mês R$:43,99</p>
                                        <div className="row center w100 ">
                                            {/*
                                            <label className="fs06em sublinhado">R$:200,00 por :</label>
                                            <h4 className=" c3 fs08em">R$:179.90</h4>
                                            <label className="c3 fs08em">,00</label>
                                            <label className="fs06em c3">/Mês</label>
                                            */}
                                            <label className="fs08em ma10b0">Segundo Mês em diante R$139 Reais</label>
                                            <label className="fs06em c3 cen w90"> Politica de descontos sob consulta com analista. Preços especiais para colaboradores que contribuam com sugestões de desenvolvimentos e feedbacks.</label>
                                            
                                        </div>
                                        
                                        
                                        <div className="w80 column fb fs08em ma10b0 pp c2">Termos e condições</div>
        
                                    
                                </div>
                            </div>
                        </div>
                </div>
        </section>

        <section className="w100 b2 h60 column center">
            <div className="w80 column">
                <h4 className="ma20b0">📝 Termos e Condições</h4>
                <label className="fs09em c4 jus">
                    1. Sobre o Programa

                    O Programa de Afiliados Auto Métricas tem como objetivo recompensar usuários que indicam novos clientes para o sistema Auto Métricas, oferecendo comissões mensais recorrentes sobre assinaturas ativas.

                    2. Valor da Comissão

                    Cada afiliado receberá R$ 60,00 (sessenta reais) por cada licença ativa indicada, desde que as condições descritas neste regulamento sejam cumpridas.

                    3. Condições para Recebimento

                    Para que o afiliado tenha direito ao pagamento, é necessário:

                    Ter no mínimo 2 (duas) indicações ativas no momento da análise do pagamento.

                    Que o cliente indicado tenha permanecido ativo por pelo menos 30 (trinta) dias consecutivos após a data da ativação da assinatura.

                    Que o cliente indicado tenha realizado o pagamento da mensalidade, estando em dia e sem inadimplência.

                    ⚠️ Não serão pagos valores referentes a clientes inadimplentes, cancelados ou suspensos.

                    4. Pagamento

                    Os pagamentos das comissões serão realizados todo dia 15 (décimo quinto) dia útil de cada mês.

                    O valor será calculado com base nas licenças ativas e adimplentes até o último dia do mês anterior.

                    O pagamento será efetuado via transferência bancária ou PIX cadastrado pelo afiliado.

                    Caso o valor mínimo de R$ 120,00 (duas indicações) não seja atingido, o saldo será acumulado para o mês seguinte.

                    5. Atividades e Indicações

                    Cada novo cliente deve realizar sua assinatura do sistema Auto Métricas com o link exclusivo de afiliado.

                    O afiliado não pode criar múltiplas contas próprias para gerar comissões fraudulentas.

                    Indicações inválidas, fraudulentas ou com informações incorretas serão desconsideradas.

                    6. Suspensão e Cancelamento

                    A Auto Métricas se reserva o direito de suspender ou cancelar a participação de afiliados que:

                    Tentarem burlar as regras;

                    Usarem práticas enganosas de divulgação;

                    Não respeitarem os termos deste regulamento.

                    7. Alterações do Programa

                    A Auto Métricas poderá alterar as regras, valores ou prazos deste programa a qualquer momento, mediante aviso prévio aos afiliados cadastrados.

                    8. Disposições Finais

                    A participação no Programa de Afiliados implica a aceitação total destes termos.
                    A Auto Métricas não se responsabiliza por atrasos bancários, dados incorretos informados pelo afiliado ou situações de força maior que impeçam o pagamento na data prevista.

                    Auto Métricas – Programa de Afiliados
                    💻 Transforme suas indicações em renda recorrente.
                    📅 Pagamentos garantidos para quem indica e mantém clientes ativos!
                </label>
                <div className="w30 cell-tamanho">
                    <button    
                        className="btn07"      
                        onClick={() => {
                        const el = document.getElementById("cadastro");
                        if (el) el.scrollIntoView({ behavior: "smooth" });
                        }}>                    
                        Inscreva-se
                </button>
                </div>
               
            </div>
        </section>


        <footer className="w100 h5 b1 row center">
            <label className="c6 cen">MobiAPPs - 2025 Copyright - todos os direitos reservados </label>
        </footer>
      </div>
    )
}

